import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import LoadingAnim from "../global/loadingAnim";
import { getHeaderHeight, getString, isLoggedInWithoutRole, offset } from "../../utilities";
import { userRoles, contentTypes, FREE_GAMES_LIST_COUNT, getLangCode, getFreeGamesHash } from "../../config";
import List from "../global/list";
import { dataSelector, loadingSelector } from "../../redux/slices/dataSlice";
import { getGOTWList } from "../../utilities/games";
import { useLocation } from "react-router";

export default function FreeGames() {
  const { hash } = useLocation();
  const [freeGamesList, setFreeGamesList] = useState([]);
  const [loading, setLoading] = useState(true);

  const dataLoading = useSelector(loadingSelector);
  const data = useSelector(dataSelector);

  useEffect(() => {
    if (!dataLoading) {
      if (data.lists) {
        const nextFreeGamesList = getGOTWList(data.lists);
        if (nextFreeGamesList?.items?.length > FREE_GAMES_LIST_COUNT) {
          nextFreeGamesList.items = nextFreeGamesList.items.slice(0, FREE_GAMES_LIST_COUNT);
        }

        setFreeGamesList(nextFreeGamesList);
        setLoading(dataLoading);
      }
    }
  }, [dataLoading, data]);

  const freeGamesCallback = useCallback(
    (node) => {
      if (node && hash === `#${getFreeGamesHash()}`) {
        setTimeout(() => {
          const contentPosition = offset(node).top - getHeaderHeight();
          window.scroll({ left: 0, top: contentPosition });
        }, 200);
      }
    },
    [hash],
  );

  const renderList = () => {
    if (loading) {
      return <LoadingAnim />;
    }
    if (freeGamesList?.items.length > 0) {
      // const listPlatform = freeGamesList.platform;
      // MUST hardcode until gotw list is changed to use "BOTH" in startup data/api/admin
      const listPlatform = "BOTH";
      return (
        <List
          items={freeGamesList.items.reduce((itemArray, item) => {
            const itemGame = data.games ? data.games.find((g) => g.id === item.game) : null;

            if (itemGame) {
              itemArray.push({
                type: contentTypes.game,
                title: itemGame.fullname,
                path: itemGame.localeShortname || itemGame.shortname,
                image: itemGame.miniBanner ? itemGame.miniBanner : null,
                grades: itemGame.grades,
                order: item.order,
                mobile: itemGame.mobileActive,
                searchable: itemGame.searchable,
              });
            }

            return itemArray;
          }, [])}
          platform={listPlatform}
          sort="order"
          className="cyan"
        />
      );
    }

    return null;
  };

  if (!isLoggedInWithoutRole(userRoles.free)) {
    const langCode = getLangCode();

    return (
      <div ref={freeGamesCallback} className="home-free-games">
        <div className={`home-free-games-title ${langCode}`}>{getString("freeGames.title")}</div>

        <div className={`home-free-games-subtitle ${langCode}`}>{getString("freeGames.subtitle")}</div>

        <div className="home-free-games-list">{renderList()}</div>
      </div>
    );
  }

  return null;
}
